import script from "./PastEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./PastEvents.vue?vue&type=script&setup=true&lang=js"

import "./PastEvents.vue?vue&type=style&index=0&id=b0b516a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0b516a2"]])

export default __exports__